module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-horizon-pool.f853095f.jpg";